module.exports = require('./dist/src/general/dist/components/HorizontalRatio.js');
